const baseURL = 'http://49.235.164.72:911/'
const localBaseURL = 'https://localhost:44328/'
const isOnline=false;

export default {
  baseURL,
  localBaseURL,
  isOnline,
}